var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "playsmart-table" }, [_c('el-card', [_c('h5', [_vm._v("PlaySmart每周发布素材统计")]), _vm._v(" "), _c('TableList', { attrs: { "columnConfig": _vm.columnConfig, "list": _vm.list } })], 1)], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };